import styled from 'styled-components';
import { sizes } from 'modules/journey/card/styled/media';

export const styledDriverJourneys = (component) => styled(component)`
  && {
    border-radius: 8px;
    font-size: 11px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);

    .tippy-content {
      background-color: var(--grey100);
      outline: 10px solid transparent;
      width: 1100px;
      max-height: 500px;

      @media only screen and (max-width: ${sizes.medium}px) {
        width: 1000px;
      }

      @media only screen and (max-width: ${sizes.small}px) {
        width: 900px;
      }
    }
  }
`;

export const styledList = (component) => styled(component)`
  width: 1300px;
  transform: scale(0.85);
  margin-left: -100px;
  font-size: 14px;
  max-height: 490px;
  overflow-y: scroll;

  @media only screen and (max-width: ${sizes.medium}px) {
    width: 1150px;
  }

  @media only screen and (max-width: ${sizes.small}px) {
    width: 1000px;
  }
`;
